// src/components/pages/Radiology/radiologyData.js
import babycareimg2 from "../../Assets/babycareimg2.png";
import plethora1 from "../../Assets/plethora1.png";
import plethora2 from "../../Assets/plethora2.png";
import plethora3 from "../../Assets/plethora3.png";
import plethora4 from "../../Assets/plethora4.png";
import plethora5 from "../../Assets/plethora5.png";
import plethora6 from "../../Assets/plethora6.png";
import plethora7 from "../../Assets/plethora7.png";
import plethora8 from "../../Assets/plethora8.png";
import { heading, paragraph } from "../BabyCare/BabyCareData";
import transforming from "../../Assets/transforming.png"
import boon1 from "../../Assets/boon1.png"
import boon2 from "../../Assets/boon2.png"
import boon3 from "../../Assets/boon3.png"
import boon4 from "../../Assets/boon4.png"
import boon5 from "../../Assets/boon5.png"
import boon6 from "../../Assets/boon6.png"
import bhargavi from "../../Assets/bhargavi.png"
import naveen from "../../Assets/naveen.png"
import vinod from "../../Assets/vinod.png"
import radiologyimg from "../../Assets/radiologyimg.png"

export const serviceShowcaseData = [
  {
    imgSrc: radiologyimg,
    title: `Radiology Redefined \n Home Based, \n Hassle Free`,
    buttonText: "Book Now",
    onButtonClick: () => console.log("Button Clicked"),
  },
];

export const heading1 = "In Your Environment";
export const heading2 = "On Your Schedule";
export const paragraph1 = `With "In Your Environment, On Your Schedule" as our motto, we bring advanced radiology technology directly to your doorstep,
ensuring you can undergo essential tests without disrupting your daily routine or compromising your comfort.`

export const plethoraHeading = `Our Plethora Of Services`;

export const plethoraOfServices = {
  
  o1: { title: "X-Ray", img: plethora1 },
  o2: { title: "ECG", img: plethora2 },
  o3: { title: "Sleep Study", img: plethora3 },
  o4: { title: "Holter Study", img: plethora4 },
  o5: { title: "Bone Density Screenings", img: plethora5 },
  o6: { title: "Doppler Tests", img: plethora6 },
  o7: { title: "PaceMakers Check", img: plethora7 },
  o8: { title: "Ultrasounds", img: plethora8 },
};

export const premierOptionData = {
  heading: `Why We’re Premier Option`,
  list: [
    {
      text: "Convenience",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
      ,
    },
    {
      text: "Precision",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
      ,
    },
    {
      text: "Sustainability",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>
      )
    },
    {
      text: "Expediency",
      icon: (<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0098 8.28192L2.4071 13.8672L4.07046 9.56669L11.5124 8.17328L4.11557 6.14345L2.77028 1.88622L16.0077 8.28382L16.0098 8.28192ZM1.68147 15.2909L17.4465 8.81739C17.5149 8.79603 17.5782 8.76071 17.6322 8.71366C17.6863 8.66661 17.73 8.60886 17.7606 8.54408C17.8212 8.41922 17.8299 8.27554 17.7846 8.14458C17.7394 8.01361 17.644 7.90605 17.5194 7.84549L2.13919 0.416245C2.04738 0.372449 1.94473 0.356397 1.8438 0.370051C1.74288 0.383706 1.64805 0.426475 1.57093 0.493122C1.49382 0.559771 1.43776 0.647409 1.40961 0.74531C1.38146 0.843209 1.38245 0.947121 1.41246 1.04433L3.58551 7.93233L0.998363 14.6229C0.961716 14.7179 0.953672 14.8215 0.975223 14.9209C0.996775 15.0202 1.04698 15.111 1.11963 15.1821C1.19229 15.2531 1.28421 15.3013 1.38406 15.3206C1.4839 15.34 1.58729 15.3296 1.68147 15.2909Z" fill="#1D808C" />
      </svg>)
    },
  ],
};

export const transformingData = {
  image: transforming,
  heading: "Transforming Healthcare",
  paragraph: `Utilizing state of the art digital technology, our system captures high-resolution radiographic images with exceptional clarity and detail. This digital capability ensures quick
   image acquisition and instant viewing, enabling healthcare providers to make informed decisions promptly.`
}

export const boonData = {
  b1: { title: "Elderly", img: boon1 },
  b2: { title: "Bedridden", img: boon2 },
  b3: { title: "Critically injured", img: boon3 },
  b4: { title: "Broken limbs", img: boon4 },
  b5: { title: "Post Surgical Patients", img: boon5 },
  b6: { title: "Individuals with terminal disease", img: boon6 },
}

export const impactData = [
  {
    title: `The Impact We Made`,
    desc: `I can't thank the wihan team enough for their home radiology service. As
a caregiver for my elderly parent, it's challenging to get them to
appointments. This service allowed us to get the necessary X-rays
without the hassle of travel.`,
    userimg: bhargavi,
    username: "Bhargavi"

  },
  {
    desc: `I was initially hesitant about home radiology, but I'm so glad I tried wihan
home health services. The process was smooth, and the results were
delivered promptly. It's such a convenient option for busy individuals.`,
    userimg: naveen,
    username: "Naveen"

  },
  {
desc: `Getting my X-ray done at home through Wihan Home Health Services was incredibly convenient. The technician arrived on time with all the equipment, and the results were shared quickly. I’ll definitely choose them again for any future tests.`,

    userimg: vinod,
    username: "Vinod"

  },
]
export const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: false,
  pauseOnFocus: false,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2, arrows: false } },
    { breakpoint: 768, settings: { slidesToShow: 2, arrows: false } },
    { breakpoint: 480, settings: { slidesToShow: 1, arrows: false } },
  ],
};
export const truncateLetters = (str, num) => {
  return str.length > num ? str.slice(0, num) + "..." : str;
};
